import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { ACTION_BY_FILTERS_KEY } from "@/Constants/common";
import { _fetchContractShifts } from "@/services/clientcontractdetail";
import {
  _fetchUnfilledContracts,
  _checkJobCretariaForCandidate,
  _unfilledProposedShiftsContract,
} from "@/services/clientcontracts";
import {
  _fetchCandidatesForProposeCandidate,
  _getContractShiftDataForProposeCandidate,
} from "@/services/clientUnfilled";
import {
  handleAPICatch,
  showErrorToast,
  showSuccessToast,
} from "@/utilities/utils";

import {
  formatCandidateForProposeContract,
  formatContractShifts,
  formatUnfilledContracts,
} from "../utilities/dataFormatter";
import logger from "../utilities/logger";

const initialState = {
  isLoading: false,
  isPaginationLoading: false,
  unfilledContracts: [],
  selectedContracts: [], // list of candidate email
  filters: {
    search: "",
    contractReferenceNo: "",
    roleId: [],
    createdDateFrom: "",
    createdDateTo: "",
    shiftDateFrom: "",
    shiftDateTo: "",
    contractStatus: [],
    ...ACTION_BY_FILTERS_KEY,
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  totalCount: 0,
  isSelectedAll: false,
  oldFilters: {},
  toggleSelected: false,
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  showFilters: false,
  appliedCandidateForContractModal: false,

  ///
  candidatesForProposeCandidate: [],
  selectedCandidatesForProposeCandidate: [],

  proposedFilters: {
    search: "",
  },
  proposedSorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  proposedPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },

  selectedContractRole: [],
  isProposedListLoading: false,

  showProposeCandidateShiftsCalendar: false,

  shiftsForProposeCandidate: [],
  selectedCandidateDatesforPropose: {},
};

export const fetchUnfilledContractShifts = createAsyncThunk(
  "contractsUnfilled/fetchUnfilledContractShifts",
  async (data, thunkAPI) => {
    const contractID = data.contract_id;
    const response = _fetchContractShifts(data);
    response
      .then((res) => {
        const {
          data: { contract_shifts = [] },
        } = res;
        const data = formatContractShifts(contract_shifts);

        thunkAPI.dispatch(
          updateUnfilledContractShifts({
            contract_id: contractID,
            shifts: data,
          }),
        );
      })
      .catch((error) => {
        logger.error(error);
        handleAPICatch(error);
        // return thunkAPI.rejectWithValue(error);
      });
  },
);

export const fetchUnfilledContracts = createAsyncThunk(
  "candidatesUnfilled/fetchUnfilledContracts",
  async (data, { dispatch, getState }) => {
    const {
      clientUnfilledContracts: {
        filters,
        pagination,
        sorting,
        unfilledContracts,
      },
    } = getState();

    if (_.isEmpty(data)) {
      data = {
        ...filters,
      };
    }
    if (pagination.isLastPage) {
      return dispatch(setUnfilledContractsLoading(false));
    }

    dispatch(setPaginationLoading(pagination.currentPage !== 1));
    dispatch(toggleSelectedAll(false));

    const _data = {
      ...data,
      currentPage: pagination.currentPage,
      ...sorting,
    };
    const response = _fetchUnfilledContracts(_data);
    response
      .then((res) => {
        const {
          data: { unfilled_contracts, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        const data = formatUnfilledContracts(unfilled_contracts);
        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList = currentPage === 1 ? [] : _.uniq(unfilledContracts);
        dispatch(updateTotalCount(totalCount));
        let firstcontract_id = data.length > 0 ? data[0].contract_id : null;

        if (
          prevList.length > 0 &&
          prevList.find((item) => item.contract_id === firstcontract_id) !==
            undefined
        ) {
          //
        } else {
          dispatch(updateUnfilledContracts([...prevList, ...data]));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setUnfilledContractsLoading(false));
          dispatch(setPaginationLoading(false));
        }, 10);
      });
  },
);

export const fetchProposeCandidates = createAsyncThunk(
  "candidatesUnfilled/fetchProposeCandidates",
  async (data, { dispatch, getState }) => {
    const clientUnfilledContracts = getState().clientUnfilledContracts;
    let paginationData = clientUnfilledContracts?.proposedPagination;
    let filtersData = clientUnfilledContracts?.proposedFilters;
    let sortingData = clientUnfilledContracts?.proposedSorting;
    let selectedRoles = clientUnfilledContracts?.selectedContractRole;

    if (_.isEmpty(data)) {
      data = {
        ...filtersData,
      };
    }
    if (paginationData.isLastPage) {
      return dispatch(setProposedListCandidatesLoading(false));
    }

    const _data = {
      ...data,
      contract_role_id: selectedRoles.join(","),
      currentPage: paginationData.currentPage,
      ...sortingData,
    };

    dispatch(toggleProposedSelectedAll(false));

    const response = _fetchCandidatesForProposeCandidate(_data);
    response
      .then((res) => {
        const {
          data: { candidates, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let data = formatCandidateForProposeContract(candidates);
        dispatch(
          updateProposedPagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList =
          currentPage === 1
            ? []
            : _.uniq(
                getState().clientUnfilledContracts
                  .candidatesForProposeCandidate,
              );
        let firstcandidate_email =
          data.length > 0 ? data[0].candidate_email : null;
        dispatch(updateProposedTotalCount(totalCount));
        if (
          prevList.length > 0 &&
          prevList.find(
            (item) => item.candidate_email === firstcandidate_email,
          ) !== undefined
        ) {
          //
        } else {
          dispatch(updateCandidatesForProposeCandidate([...prevList, ...data]));
        }

        const unfilledContracts =
          getState().clientUnfilledContracts.unfilledContracts;
        const selectedContracts =
          getState().clientUnfilledContracts.selectedContracts;
        const selectedContract =
          unfilledContracts?.find(
            (contract) => contract?.contract_id == selectedContracts[0],
          ) || null;

        dispatch(
          fetchContractShiftDataForProposeCandidate({
            contract_id: selectedContract.contract_id,
          }),
        );
      })
      .catch((error) => {
        console.log("error", error);
        handleAPICatch(error);
        // return rejectWithValue(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setProposedListCandidatesLoading(false));
        }, 12);
      });
  },
);

export const proposedUnfilledShiftsData = createAsyncThunk(
  "candidatesUnfilled/proposedUnfilledShiftsData",
  async (data, { dispatch }) => {
    const { loading, setLoading, payload, callback } = data;

    if (loading) return;
    setLoading(true);

    const response = _unfilledProposedShiftsContract(payload);
    response
      .then((res) => {
        // return;
        const {
          data: { message = "" },
        } = res || {};
        dispatch(toggleAppliedCandidateForContractModal(false));
        showSuccessToast(message);
        callback && callback();
      })
      .catch((error) => {
        console.log(error);
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);

export const checkJobCretariaForCandidate = createAsyncThunk(
  "candidatesUnfilled/checkJobCretariaForCandidate",
  async (data, { dispatch }) => {
    const { loading, setLoading, payload, callback, navigateCallback } = data;
    if (loading) return;

    const response = _checkJobCretariaForCandidate(payload);
    response
      .then((res) => {
        // const {
        //   data: { message = "" } = {},
        // } = res || {};
        const isAllowToApply = res?.data?.is_allow_to_apply;

        /**
         * If the candidate does not meet the job criteria, show an error toast and return early.
         */
        if (!isAllowToApply) {
          const errorMessage = res?.data?.message || res;
          // Handle missing enhanced documents
          if (errorMessage === "not_uploaded_enhance_documents") {
            // Parse the applicant_data to get candidate count
            let applicantData;

            applicantData = JSON.parse(payload?.applicant_data);

            // Check if only ONE candidate was selected
            const candidateCount = Array.isArray(applicantData)
              ? applicantData.length
              : 1;

            if (candidateCount === 1) {
              // REDIRECT for single candidate
              const candidateId =
                res?.data?.candidate_id || applicantData[0]?.candidate_id;

              const remainingEnhanceIds =
                res?.data?.remaining_enhance_compliance_ids || [];

              // Store context in session storage with flag
              sessionStorage.setItem(
                "proposeRedirect",
                JSON.stringify({
                  from: "propose_candidate",
                  reason: "missing_enhanced_documents",
                  candidateId: candidateId,
                  contractId: payload?.contract_id,
                  missingDocs: res?.data?.missing_documents || [],
                  remainingEnhancedIds: remainingEnhanceIds,
                  returnUrl: window.location.pathname,
                  timestamp: Date.now(),
                }),
              );

              let a = confirm(
                "The candidate is missing enhanced documents. Please upload required documents before proposing.",
              );

              if (a) {
                // Redirect to candidate edit page
                navigateCallback(candidateId);
              }
              return;
            } else {
              // SHOW TOAST for multiple candidates
              const errorCount =
                res?.data?.candidates_with_errors?.length || candidateCount;

              showErrorToast(
                `${errorCount} candidate(s) are missing enhanced documents. Please upload required documents before proposing.`,
              );

              setLoading(false);
              return;
            }
          }

          // Show generic error for other cases
          showErrorToast(
            errorMessage || "The candidate does not meet the job criteria.",
          );
          setLoading(false);
          return;
        }

        const isCheckFailed =
          res?.data?.is_payment_method_err ||
          res?.data?.is_skill_err ||
          res?.data?.is_clinical_system_err;

        if (isCheckFailed) {
          const errorMessage = res?.data?.message || "";
          let processFurther = confirm(
            `${errorMessage} \nAre you sure you want to proceed?`,
          );
          if (processFurther) {
            dispatch(proposedUnfilledShiftsData(data));
          }
          return;
        } else {
          dispatch(proposedUnfilledShiftsData(data));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);

// _getContractShiftDataForProposeCandidate

export const fetchContractShiftDataForProposeCandidate = createAsyncThunk(
  "candidatesUnfilled/fetchContractShiftDataForProposeCandidate",
  async (data, { dispatch, getState }) => {
    const response = _getContractShiftDataForProposeCandidate(data);
    response
      .then((res) => {
        console.log("fetchContractShiftDataForProposeCandidate", res);

        const shiftList = res?.data?.data || [];
        // const shiftList = [
        //   {
        //     shift_id: 54826,
        //     contract_date: "15/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54827,
        //     contract_date: "16/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54828,
        //     contract_date: "17/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54829,
        //     contract_date: "18/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54830,
        //     contract_date: "19/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54831,
        //     contract_date: "20/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54832,
        //     contract_date: "21/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54833,
        //     contract_date: "22/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54834,
        //     contract_date: "23/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54835,
        //     contract_date: "24/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54836,
        //     contract_date: "25/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54837,
        //     contract_date: "26/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54838,
        //     contract_date: "27/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54839,
        //     contract_date: "28/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54840,
        //     contract_date: "29/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54841,
        //     contract_date: "30/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54842,
        //     contract_date: "31/10/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54843,
        //     contract_date: "01/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54844,
        //     contract_date: "02/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54845,
        //     contract_date: "03/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54846,
        //     contract_date: "04/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54847,
        //     contract_date: "05/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54848,
        //     contract_date: "06/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54849,
        //     contract_date: "07/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54850,
        //     contract_date: "08/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54851,
        //     contract_date: "09/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54852,
        //     contract_date: "10/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54853,
        //     contract_date: "11/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54854,
        //     contract_date: "12/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54855,
        //     contract_date: "13/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54856,
        //     contract_date: "14/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54857,
        //     contract_date: "15/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54858,
        //     contract_date: "16/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54859,
        //     contract_date: "17/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54860,
        //     contract_date: "18/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54861,
        //     contract_date: "19/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54862,
        //     contract_date: "20/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54863,
        //     contract_date: "21/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54864,
        //     contract_date: "22/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54865,
        //     contract_date: "23/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54866,
        //     contract_date: "24/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54867,
        //     contract_date: "25/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54868,
        //     contract_date: "26/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54869,
        //     contract_date: "27/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54870,
        //     contract_date: "28/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54871,
        //     contract_date: "29/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54872,
        //     contract_date: "30/11/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54873,
        //     contract_date: "01/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54874,
        //     contract_date: "02/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54875,
        //     contract_date: "03/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54876,
        //     contract_date: "04/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54877,
        //     contract_date: "05/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54878,
        //     contract_date: "06/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54879,
        //     contract_date: "07/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54880,
        //     contract_date: "08/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54881,
        //     contract_date: "09/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54882,
        //     contract_date: "10/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54883,
        //     contract_date: "11/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54884,
        //     contract_date: "12/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54885,
        //     contract_date: "13/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54886,
        //     contract_date: "14/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54887,
        //     contract_date: "15/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54888,
        //     contract_date: "16/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54889,
        //     contract_date: "17/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54890,
        //     contract_date: "18/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54891,
        //     contract_date: "19/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54892,
        //     contract_date: "20/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54893,
        //     contract_date: "21/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54894,
        //     contract_date: "22/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54895,
        //     contract_date: "23/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54896,
        //     contract_date: "24/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54897,
        //     contract_date: "25/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54898,
        //     contract_date: "26/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54899,
        //     contract_date: "27/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54900,
        //     contract_date: "28/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54901,
        //     contract_date: "29/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54902,
        //     contract_date: "30/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54903,
        //     contract_date: "31/12/2025",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54904,
        //     contract_date: "01/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54905,
        //     contract_date: "02/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54906,
        //     contract_date: "03/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54907,
        //     contract_date: "04/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54908,
        //     contract_date: "05/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54909,
        //     contract_date: "06/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54910,
        //     contract_date: "07/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54911,
        //     contract_date: "08/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54912,
        //     contract_date: "09/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54913,
        //     contract_date: "10/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54914,
        //     contract_date: "11/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54915,
        //     contract_date: "12/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54916,
        //     contract_date: "13/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54917,
        //     contract_date: "14/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54918,
        //     contract_date: "15/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54919,
        //     contract_date: "16/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54920,
        //     contract_date: "17/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54921,
        //     contract_date: "18/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54922,
        //     contract_date: "19/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54923,
        //     contract_date: "20/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54924,
        //     contract_date: "21/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54925,
        //     contract_date: "22/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54926,
        //     contract_date: "23/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54927,
        //     contract_date: "24/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54928,
        //     contract_date: "25/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54929,
        //     contract_date: "26/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54930,
        //     contract_date: "27/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54931,
        //     contract_date: "28/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54932,
        //     contract_date: "29/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54933,
        //     contract_date: "30/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54934,
        //     contract_date: "31/01/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54935,
        //     contract_date: "01/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54936,
        //     contract_date: "02/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54937,
        //     contract_date: "03/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54938,
        //     contract_date: "04/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54939,
        //     contract_date: "05/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54940,
        //     contract_date: "06/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54941,
        //     contract_date: "07/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54942,
        //     contract_date: "08/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54943,
        //     contract_date: "09/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54944,
        //     contract_date: "10/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54945,
        //     contract_date: "11/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54946,
        //     contract_date: "12/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54947,
        //     contract_date: "13/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54948,
        //     contract_date: "14/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54949,
        //     contract_date: "15/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54950,
        //     contract_date: "16/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54951,
        //     contract_date: "17/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54952,
        //     contract_date: "18/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54953,
        //     contract_date: "19/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54954,
        //     contract_date: "20/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54955,
        //     contract_date: "21/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54956,
        //     contract_date: "22/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54957,
        //     contract_date: "23/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54958,
        //     contract_date: "24/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54959,
        //     contract_date: "25/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54960,
        //     contract_date: "26/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54961,
        //     contract_date: "27/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54962,
        //     contract_date: "28/02/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54963,
        //     contract_date: "01/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54964,
        //     contract_date: "02/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54965,
        //     contract_date: "03/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54966,
        //     contract_date: "04/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54967,
        //     contract_date: "05/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54968,
        //     contract_date: "06/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54969,
        //     contract_date: "07/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54970,
        //     contract_date: "08/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54971,
        //     contract_date: "09/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54972,
        //     contract_date: "10/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54973,
        //     contract_date: "11/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54974,
        //     contract_date: "12/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54975,
        //     contract_date: "13/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54976,
        //     contract_date: "14/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54977,
        //     contract_date: "15/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54978,
        //     contract_date: "16/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54979,
        //     contract_date: "17/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54980,
        //     contract_date: "18/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54981,
        //     contract_date: "19/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54982,
        //     contract_date: "20/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54983,
        //     contract_date: "21/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54984,
        //     contract_date: "22/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54985,
        //     contract_date: "23/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54986,
        //     contract_date: "24/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54987,
        //     contract_date: "25/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54988,
        //     contract_date: "26/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54989,
        //     contract_date: "27/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54990,
        //     contract_date: "28/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54991,
        //     contract_date: "29/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        //   {
        //     shift_id: 54992,
        //     contract_date: "30/03/2026",
        //     start_time: "10:00:00",
        //     end_time: "12:00:00",
        //     break_time: "00:00:00",
        //     admin_time: "00:00:00",
        //     no_of_visit: 0,
        //     shift_rate: 300,
        //     unit: "2.00",
        //     timesheet_status: "-",
        //     client_pay_arr: [
        //       {
        //         client_pay: 150,
        //         unit: "2.00",
        //         total_visit_amount_per_day: 0,
        //         total_no_of_visit: 0,
        //         total: 300,
        //       },
        //     ],
        //     visit_charge: 0,
        //     cover_request_awarded_reward: 0,
        //   },
        // ];
        dispatch(updateShiftsForProposeCandidate(shiftList));
        const candidatesForProposeCandidate =
          getState().clientUnfilledContracts.candidatesForProposeCandidate;
        const initialValue = {};
        candidatesForProposeCandidate.forEach((candidate) => {
          initialValue[candidate.candidate_id] = shiftList;
        });
        dispatch(updateSelectedCandidateDatesforPropose(initialValue));
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

const contractsUnfilledSlice = createSlice({
  name: "contractsUnfilled",
  initialState,
  reducers: {
    updateUnfilledContracts: (state, action) => {
      state.unfilledContracts = action.payload;
    },
    updatePagination: (state, action) => {
      state.pagination = action.payload;
    },
    setUnfilledContractsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPaginationLoading(state, action) {
      state.isPaginationLoading = action.payload;
    },
    updateToggleSelected: (state, action) => {
      state.toggleSelected = !state.toggleSelected;
    },
    deSelectAllContract: (state, action) => {
      state.selectedContracts = [];
      state.isSelectedAll = false;
      state.toggleSelected = !state.toggleSelected;
    },
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },

    updateProposedFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.proposedFilters = {
          search: state.proposedFilters.search,
          ...initialState.proposedFilters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.proposedFilters = initialState.proposedFilters;
        } else {
          state.proposedFilters = {
            ...state.proposedFilters,
            ...action.payload,
          };
        }
      }
    },
    updateSorting: (state, action) => {
      state.sorting = action.payload;
    },
    updateOldFilters: (state, action) => {
      state.oldFilters = action.payload;
    },
    // toggleShowFilters: (state, action) => {
    //   state.showFilters = action.payload;
    // },
    updateSelectedContracts: (state, action) => {
      state.selectedContracts = action.payload;
      if (action.payload.length === 0) {
        state.isSelectedAll = false;
      }
    },
    updateUnfilledContractShifts: (state, action) => {
      state.unfilledContracts = state.unfilledContracts.map((contract) => {
        if (contract.contract_id === action.payload.contract_id) {
          contract.shifts = action.payload.shifts;
        }
        return contract;
      });
    },

    updateTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    toggleSelectedAll: (state, action) => {
      state.isSelectedAll = action.payload;
    },
    showFilterModal: (state, action) => {
      if (action.payload) {
        state.oldFilters = state.filters;
      }
      state.showFilters = action.payload;
    },
    reStateFilters: (state, action) => {
      state.filters = state.oldFilters;
    },
    updateCandidateStatus: (state, action) => {
      let { unsuitable, sortlisted, isSelectedAll, ignoreIds, ids } =
        action.payload;
      let _ids = ids.map((id) => id.toString());
      let _ignoreIds = ignoreIds.map((id) => id.toString());
      state.bookedCandidates = state.bookedCandidates.map((candidate) => {
        if (_ignoreIds.includes(candidate?.candidate_id?.toString())) {
          return candidate;
        }
        if (
          _ids.includes(candidate?.candidate_id?.toString()) ||
          isSelectedAll
        ) {
          candidate.candidate_unsuitable = unsuitable;
          candidate.candidate_sortlisted = sortlisted;
        }
        return candidate;
      });
    },

    toggleAppliedCandidateForContractModal: (state, action) => {
      state.appliedCandidateForContractModal = action.payload;
    },
    updateCandidatesForProposeCandidate: (state, action) => {
      state.candidatesForProposeCandidate = action.payload;
    },

    updateSelectedCandidatesForProposeCandidate: (state, action) => {
      state.selectedCandidatesForProposeCandidate = action.payload;
    },
    toggleProposedSelectedAll: (state, action) => {
      state.isProposedSelectedAll = action.payload;
    },
    deSelectShortListAllCandidate: (state, action) => {
      state.selectedCandidatesForProposeCandidate = [];
      state.isProposedSelectedAll = false;
    },
    updateSelectedContractRoles: (state, action) => {
      state.selectedContractRole = action.payload;
    },
    updateProposedPagination: (state, action) => {
      state.proposedPagination = {
        ...state.proposedPagination,
        ...action.payload,
      };
    },
    updateProposedTotalCount: (state, action) => {
      state.proposedTotalCount = action.payload;
    },
    setProposedListCandidatesLoading: (state, action) => {
      state.isProposedListLoading = action.payload;
    },
    toggleProposeCandidateShiftsCalendar: (state, action) => {
      let newValue =
        action.payload ?? !state.showProposeCandidateShiftsCalendar;
      state.showProposeCandidateShiftsCalendar = newValue;
    },
    updateShiftsForProposeCandidate: (state, action) => {
      state.shiftsForProposeCandidate = action.payload;
    },
    updateSelectedCandidateDatesforPropose: (state, action) => {
      state.selectedCandidateDatesforPropose = {
        ...state.selectedCandidateDatesforPropose,
        ...action.payload,
      };
    },
  },
});

export const {
  updateUnfilledContracts,
  updatePagination,
  setUnfilledContractsLoading,
  setPaginationLoading,
  deSelectAllContract,
  updateToggleSelected,
  updateFilters,
  updateOldFilters,
  updateSorting,
  updateSelectedContracts,
  updateUnfilledContractShifts,
  updateTotalCount,
  toggleSelectedAll,
  showFilterModal,
  reStateFilters,
  updateCandidateStatus,

  toggleAppliedCandidateForContractModal,
  updateCandidatesForProposeCandidate,
  updateSelectedCandidatesForProposeCandidate,
  deSelectShortListAllCandidate,
  updateSelectedContractRoles,
  updateProposedPagination,
  updateProposedTotalCount,
  setProposedListCandidatesLoading,
  toggleProposedSelectedAll,
  updateProposedFilters,
  toggleProposeCandidateShiftsCalendar,

  updateShiftsForProposeCandidate,

  updateSelectedCandidateDatesforPropose,
} = contractsUnfilledSlice.actions;

export default contractsUnfilledSlice.reducer;
